// extracted by mini-css-extract-plugin
export default {"form":"EditarDistribuidor_form__D4EZ-","areaBtn":"EditarDistribuidor_areaBtn__jGMp+","btn":"EditarDistribuidor_btn__9PoV1"};